import { Link } from 'react-router-dom';

export default function ArtistLinks({
    artists = [],
    fallback = 'Unknown Artist',
    className = '',
}) {
    if (!artists.length) {
        return <span className={className}>{fallback}</span>;
    }

    return (
        <span className={className}>
            {artists.map((artist, index) => (
                <span key={artist.id || artist.slug} className='artist'>
                    {artist.name}
                    {index < artists.length - 1 && ', '}
                </span>
            ))}
        </span>
    );
}